$(function(){

    //formarea_inputのみ実行
    if($('.formarea_input').length){

        //離脱の警告
        $(window).on('beforeunload', function() {
            return 'フォームは未送信です。\n' +
                'このままページを移動するとフォームに入力したデータは保存されません。';
        });
        $('.js-no-withdrawal').on('click', function(e) {
            $(window).off('beforeunload');
        });

        //セレクター　選択したら
        $('select').on('change',function(){
            if( this.value == '' ){
                this.style.color = '';
            } else {
                this.style.color = '#000';
            }
        });

        // カタ自動補完
        $.fn.autoKana('.your-name', '.kana', {
            katakana : true  //true：カタカナ、false：ひらがな（デフォルト）
        });
        $.fn.autoKana('.first-name', '.first-kana', {
            katakana : true  //true：カタカナ、false：ひらがな（デフォルト）
        });

        //カタ自動補完時にバリデーションを実行
        $('.your-name').on('blur', function() {
            var kana_myoiji = $('.kana');
            if(kana_myoiji.val()) {
                kana_myoiji.validationEngine('validate');
            }
        });
        $('.first-name').on('blur', function() {
            var kana_namae = $('.first-kana');
            if(kana_namae.val()) {
                kana_namae.validationEngine('validate');
            }
        });

        // 住所自動入力
        $('.zip').attr("onKeyUp", "AjaxZip3.zip2addr(this,'','f_item_address_pref','f_item_address_city', '', '', false);");

        // 住所自動補完が完了したら
        AjaxZip3.onSuccess = function() {
            $('.address1').validationEngine('validate');
            $('.address2').focus(); // 番地、建物名にフォーカス
        };

        //全体バリデーション&残りの入力項目カウント
        var $required = $('.required');
        var $disabled = $('.js-validation-disabled');
        $disabled.prop('disabled', 'disabled');

        var requiredNum = $required.length;
        var errorNum = requiredNum - $required.filter('.is-success').length;
        $('.items, .number').text(errorNum);

        $('.formarea_input form').validationEngine('attach', {
            validationEventTrigger:'blur keyup',
            promptPosition: 'topLeft',
            addSuccessCssClassToField: 'is-success',
            addFailureCssClassToField: 'is-error',
            onFieldSuccess: function(field) {
                requiredCountDown();
            },
            onFieldFailure: function(field) {
                requiredCountDown();
            }
        });

        // ここから追加
        // if (!history.replaceState || history.state === 'visited') {
        //     $('.formarea_input form').validationEngine('validate');
        // } else {
        //     history.replaceState('visited', location.href);
        // }
        // ここまで追加

        function requiredCountDown () {
            $('.number').text(requiredNum - $required.filter('.is-success').length);
            if (requiredNum === $required.filter('.is-success').length) {
                $disabled.prop('disabled', false);
                $('body').addClass('comp');
            } else {
                $disabled.prop('disabled', 'disabled');
                $('body').removeClass('comp');
            }
        }

    }
});

$(window).on("load",function(){
    //formarea_inputのみ実行
    if($('.formarea_input').length){
        //残りの入力項目カウント　スクロールしたら表示
        var formarea_input = $('.formarea_input').offset().top;
        var hSize = $(window).height();
        var remaining = $('.remaining');
        $(window).scroll(function () {
            if ($(this).scrollTop() > formarea_input - hSize) {
                remaining.addClass("show");
            } else {
                remaining.removeClass("show");
            }
        });
    }
});

//pageshowでブラウザバック時にも発火させる
window.addEventListener('pageshow', function(event) {
    //クラス名にrequiredがあるものを取得してHTMLcollectionから配列に変換
    let required = document.getElementsByClassName('required'); 
    required = Array.from(required);
    const requiredLength = required.length;

    //必要な要素を取得して（配列なので[0]で最初の1個を指定）
    let number = document.getElementsByClassName('number');
    let submitButton = document.getElementsByClassName('btn_form');
    let body = document.getElementsByTagName('body');
    number = number[0];
    submitButton = submitButton[0];
    body = body[0];

    //必須入力済みの項目を数える変数用意
    let isSuccessNum = 0; 

    //mapで必須項目の数分繰り返し処理
    required.map( (value) => {
        //もし必須項目のタイプがチェックボックスだったら
        if (value.getAttribute('type') === 'checkbox') {
            //そのチェックボックスのname属性の値を取得
            const checkName = value.getAttribute('name');

            //同じname値を持つ要素を全て取得して配列化
            let checkList = document.getElementsByName(checkName);
            checkList = Array.from(checkList);

            //現在のチェックボックスと同じname値を持つチェックボックスを繰り返す（1つ選べば必須OKとなるグループ）（mapだとインデックス番号が使いにくいのでfor）
            for(let i = 0; i < checkList.length; i++) {
                //チェックボックスを繰り返してチェックが入ってたら
                if (checkList[i].checked) {
                    //requiredがついてるチェックボックス（最初の１つ）にis-successのクラスを付与
                    //必須チェック数に1加算
                    //1個でもチェックがあればOKなので、for文をbreak
                    value.classList.add('is-success'); 
                    isSuccessNum++; 
                    break; 
                }
            }
        
        //必須項目がチェックボックスではない場合（ラジオボタンやセレクトボックスを想定していないので注意）
        //必須項目のvalueに値があれば
        } else if (value.value !== '') {
            //classにis-successを付与して、必須OK数を加算
            value.classList.add('is-success');
            isSuccessNum++;
        }
    });

    //ここから必須の入力状況に応じた処理
    //必須項目数と入力数の差異がなければ
    if ( requiredLength - isSuccessNum === 0 ) {
        //bodyのクラスのcomp付与とsubmitのdisabledを外す
        body.classList.add('comp');
        submitButton.disabled = false;
    } else {
        //差異があれば（ブラウザバック時にここに入ることは基本的にはないはず
        //bodyからcompを削除、submitにdisabledを付与
        body.classList.remove('comp');
        submitButton.disabled = true;
    }
    
    //必須項目数の表示を更新
    number.insertAdjacentText(requiredLength - isSuccessNum);
});
